<div class="pt-2">
    <form [formGroup]="waterProtocolForm">
        <mat-form-field class="full-width mt-2" appearance="outline">
            <mat-label>Komentarz:</mat-label>
            <textarea matInput formControlName="comments" name="comments" type="text"
                      placeholder="Komentarz"
                      #comment></textarea>
            <mat-hint align="end">
                {{ comment.value.length }} / {{ commentMaxLength }}
            </mat-hint>
            <mat-error *ngIf="comments.value.length > commentMaxLength">
                Maksymalna długość wynosi {{ commentMaxLength }} znaków.
            </mat-error>
        </mat-form-field>
    </form>
</div>
